module.exports = "<span ng-init=\"tit = row.phrases.join(', ')\" title=\"{{tit}}\">{{tit}}</span>"